// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-Table-BaseTable-BaseTable-module__header";
var _2 = "webpack-concepts-Extraction-Blocks-Table-BaseTable-BaseTable-module__table";
export { _1 as "header", _2 as "table" }
